// Overnight-Redesign (Branch overnight-redesign): Live-Markt + Trödel im iOS-Stil, Gesten-Fundament
// (Swipe-to-dismiss, Tab-Swipe 1:1), Storno/Undo im Live-Markt, Demo-Modus (VITE_DEMO).
export const APP_VERSION = '0.9.107'
